export default __webpack_public_path__ + "static/img/logo-lokomotive.5bf3340.png";